export default function Maintenance() {
  return (
    <div className='maintenance'>
        <i className='bi bi-tools'></i>
        <div className='d-flex flex-column justify-content-center align-items-center'>
        <p>We are currently under maintenance.</p>
        { process.env.REACT_APP_MAINTENANCE_TEXT && <p dangerouslySetInnerHTML={{__html: process.env.REACT_APP_MAINTENANCE_TEXT}}></p>}
        </div>
    </div>
  );
}
